






































import { Component, Mixins } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import productoModule from "@/store/modules/producto-module";
import { producto } from "@/shared/dtos/producto";
import pedidoModule from "@/store/modules/pedido-module";
import { DynamicChangeEventClass } from "@/components/DinamicallyForm/DynamicChangeEventClass";
import { ProcessoNums } from "../procesos/ProcessoNums";
@Component({
  components: {},
})
export default class NewProdcuto extends Mixins(HelperDinamicallyForm) {
  public item_pantalla: any = new producto();
  condiciones: { id: number; displayText: string }[] = [];
  localizaciones: { id: number; displayText: string }[] = [];
  categoryes: { id: number; displayText: string }[] = [];
  subcategoryes: { id: number; displayText: string }[] = [];
  public async OnCreated() {
    await productoModule.getproductos();
    if (this.getparamId().HayParametro) {
      await productoModule.getproducto(this.getparamId().Parametro);

      this.item_pantalla = productoModule.producto;
    }
    await pedidoModule.getpedidos();
    //Para la clonacion automatica
    this.BasicElement = this.item_pantalla;
    this.getDistinctCondiciones();
    this.getDistinctUbicaciones();
    this.getDistinctCategory();
    this.getDistinctSubCategory();
  }

  public TabDatosbasicos() {
    this.AddFormItemDataDefaultString(
      this.item_pantalla.item_desc,
      "Nombre del producto",
      "item_desc",
      255
    )
      .Dimesiones(12, 12, 12)
      .isRequired();
    if (pedidoModule.pedidos.length === 1) {
      this.item_pantalla.id_pedido = pedidoModule.pedidos[0].id;
    }
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_pedido,
      "Pedido",
      "id_pedido"
    )
      .Dimesiones(12, 6, 3)
      .CreateComboSingle(pedidoModule.pedidos, "referencia", "id")
      .isRequired();

    this.AddFormItemDataDefaultString(this.item_pantalla.lpn, "LPN", "lpn", 60)
      .Dimesiones(12, 6, 2)
      .isRequired();

    this.AddFormItemDataDefaultString(
      this.item_pantalla.ean,
      "EAN(Codigo de barras prodcuto)",
      "ean",
      60
    ).Dimesiones(12, 6, 2);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.item_pkg_weight,
      "Peso (Kilos/Kg) Automaticamente se convierte a gramos",
      "item_pkg_weight"
    )
      .Dimesiones(12, 6, 2)
      .isRequired();

    /* Campo: Precio Venta (calculado) */
    /* this.AddFormItemDataDefaultNumber(
      this.item_pantalla.precio_venta,
      "Precio venta",
      "precio_venta"
    )
      .Dimesiones(12, 6, 4)
      .isRequired();*/
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.ultimo_precio_amazon,
      "Precio amazon",
      "unit_retail"
    )
      .Dimesiones(12, 6, 3)
      .isRequired();
    this.item_pantalla.coste_compra = 0;
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.coste_compra,
      "Coste [0 si no está en la excel] ",
      "coste_compra"
    )
      .Dimesiones(12, 6, 4)
      .isRequired();

    this.AddFormItemDataDefaultString(
      this.item_pantalla.pkg_id,
      "Localización",
      "pkg_id"
    )
      .Dimesiones(12, 6, 4)
      .CreateComboSingle(this.localizaciones, "displayText", "displayText")
      .isRequired();

    this.item_pantalla.condicion = "Creado manualmente";
    this.AddFormItemDataDefaultString(
      this.item_pantalla.condicion,
      "Condición",
      "condicion",
      60
    )
      .Dimesiones(12, 6, 4)
      .CreateComboSingle(this.condiciones, "displayText", "displayText")
      .isRequired();

    this.AddFormItemDataDefaultString(
      this.item_pantalla.category,
      "Categoría",
      "category"
    )
      .Dimesiones(12, 6, 4)
      .CreateComboSingle(this.categoryes, "displayText", "id")
      .isRequired();

    this.AddFormItemDataDefaultString(
      this.item_pantalla.subcategory,
      "Subcategoría",
      "subcategory"
    )
      .Dimesiones(12, 6, 4)
      .CreateComboSingle(this.subcategoryes, "displayText", "id")
      .isRequired();
    /* Grupo: Detalles del Producto */
    this.AddFormItemDataDefaultString(
      this.item_pantalla.asin,
      "ASIN",
      "asin",
      60
    )
      .Dimesiones(12, 6, 4)
      .isRequired();
  }
  actualizar_peso(e: DynamicChangeEventClass) {
    this.SetFormItem("item_pkg_weight").data = e.NewValue * 1000;
  }
  addLocalizacio() {
    var resp = window.prompt(
      "Escribe el nombre de la localización / codigo de barras"
    );
    if (resp) {
      this.localizaciones.push({
        id: this.localizaciones.length,
        displayText: resp,
      });

      this.SetFormItem("pkg_id")
        .Dimesiones(12, 6, 4)
        .CreateComboSingle(this.localizaciones, "displayText", "displayText")
        .isRequired().data = resp;
    }
  }
  getDistinctCondiciones() {
    const condicionesSet = new Set<string>();
    productoModule.productos.forEach((producto) => {
      if (producto.condicion) {
        condicionesSet.add(producto.condicion);
      }
    });
    this.condiciones = Array.from(condicionesSet).map((condicion, index) => ({
      id: index,
      displayText: condicion,
    }));
    if (
      this.condiciones.find((x) => x.displayText == "Creado manualmente") ==
      undefined
    ) {
      this.condiciones.push({
        id: this.condiciones.length,
        displayText: "Creado manualmente",
      });
    }
  }

  getDistinctUbicaciones() {
    const pkg_idSet = new Set<string>();
    productoModule.productos.forEach((producto) => {
      if (producto.pkg_id) {
        pkg_idSet.add(producto.pkg_id);
      }
    });
    this.localizaciones = Array.from(pkg_idSet).map((pkg_id, index) => ({
      id: index,
      displayText: pkg_id,
    }));
  }

  getDistinctCategory() {
    const categoryMap = new Map<
      number,
      {
        id: number;
        category: string;
        category_code: number;
      }
    >();
    productoModule.productos.forEach((producto) => {
      if (producto.category) {
        categoryMap.set(producto.category_code, {
          id: producto.category_code,
          category: producto.category,
          category_code: producto.category_code,
        });
      }
    });
    this.categoryes = Array.from(categoryMap.values()).map((category) => ({
      id: category.category_code,
      displayText: category.category,
      category_code: category.category_code,
    }));
  }

  getDistinctSubCategory() {
    const categoryMap = new Map<
      number,
      {
        id: number;
        sub_category: string;
        sub_category_code: number;
      }
    >();
    productoModule.productos.forEach((producto) => {
      if (producto.subcategory) {
        categoryMap.set(producto.subcat_code, {
          id: producto.subcat_code,
          sub_category: producto.subcategory,
          sub_category_code: producto.subcat_code,
        });
      }
    });
    this.subcategoryes = Array.from(categoryMap.values()).map((category) => ({
      id: category.sub_category_code,
      displayText: category.sub_category,
      category_code: category.sub_category_code,
    }));
  }

  BuscarAsin() {
    var encontrado = false;

    productoModule.productos.forEach((producto_item) => {
      if (producto_item.asin === this.GetDataItem("asin")) {
        let prodcuto_antes: producto = new producto(
          this.Formulario.GetObjectForm()
        );
        encontrado = true;
        this.item_pantalla = new producto(producto_item);
        // Asignación de valores a los campos del formulario
        this.SetFormItem("item_desc").data = this.item_pantalla.item_desc; // Nombre del producto
        this.SetFormItem("id_pedido").data = prodcuto_antes.id_pedido; // ID de pedido
        this.SetFormItem("lpn").data = prodcuto_antes.lpn; // LPN (License Plate Number)
        this.SetFormItem("item_pkg_weight").data =
          this.item_pantalla.item_pkg_weight.toFixed(0); // Peso (Gramos)
        this.SetFormItem("unit_retail").data =
          this.item_pantalla.ultimo_precio_amazon.toFixed(0); // Precio de Amazon
        this.SetFormItem("precio_venta").data = (
          this.item_pantalla.ultimo_precio_amazon / 2
        ).toFixed(0); // Precio de venta
        this.SetFormItem("coste_compra").data = prodcuto_antes.coste_compra; // Coste de compra
        this.SetFormItem("pkg_id").data = prodcuto_antes.pkg_id; // Localización
        this.SetFormItem("condicion").data = prodcuto_antes.condicion; // Condición
        this.SetFormItem("asin").data = this.item_pantalla.asin; // ASIN (Amazon Standard Identification Number)
        this.SetFormItem("category").data = this.item_pantalla.category_code;
        this.SetFormItem("subcategory").data = this.item_pantalla.subcat_code;
      } //B0BQ1FWTXG
    });

    if (!encontrado) {
      productoModule
        .extraerDatosAmazon(this.GetDataItem("asin"))
        .then((resp) => {
          if (resp) {
            this.item_pantalla = new producto(resp);
            this.SetFormItem("item_desc").data = resp.title; // Nombre del producto
            this.SetFormItem("unit_retail").data =
              resp.mi_precio_ultimo.toFixed(0); // Precio de Amazon
            this.SetFormItem("precio_venta").data = (
              resp.mi_precio_ultimo / 2
            ).toFixed(0); // Precio de venta
          }
        });
    }
  }
  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica

    this.TabDatosbasicos();
  }

  public Insertar(object: producto) {
    var producto_pedido: producto = productoModule.productos.find(
      (x) => x.id_pedido === object.id_pedido
    )!;
    // object.item_pkg_weight = object.item_pkg_weight * 1000;
    debugger;

    object.estado = ProcessoNums.Disponible; // number
    var categoria = this.categoryes.find(
      (x) => object.category.toString() === x.id.toString()
    )!;
    var sub_categoria = this.subcategoryes.find(
      (x) => object.subcategory.toString() === x.id.toString()
    )!;

    object.ultimo_precio_amazon = object.unit_retail; // number

    object.category_code = categoria.id; // number
    object.subcat_code = sub_categoria.id; // number

    object.category = categoria.displayText; // string
    object.subcategory = sub_categoria.displayText; // string

    object.gl = producto_pedido.gl; // number
    object.department = producto_pedido.department; // string
    object.gl_description = producto_pedido.gl_description; // string

    object.cost = 0; // number
    object.total_retail = object.unit_retail; // number
    object.total_cost = object.unit_retail; // number
    object.unit_retail = object.unit_retail; // number

    /* Campos adicionales */
    object.vendido = false; // boolean
    object.fecha_venta = new Date(); // Date
    object.link_amazon = "https://www.amazon.es/dp/" + object.asin; // string
    object.recibido = true; // boolean
    object.datecreated = new Date(); // Date
    object.dateupdated = new Date(); // Date

    // Asignación de valores línea por línea
    object.liquidator_vendor_code = producto_pedido.liquidator_vendor_code; // string
    object.inventory_location = producto_pedido.inventory_location; // string
    object.fc = producto_pedido.fc; // string
    object.iog = 0; // number

    object.shipment_closed = new Date(); // Date
    object.bol = producto_pedido.bol; // string
    object.carrier = producto_pedido.carrier; // string
    object.ship_to_city = producto_pedido.ship_to_city; // string

    object.removal_order_id = "0"; // string
    object.return_id = "0"; // string
    object.return_item_id = "0"; // string
    object.shipment_request_id = "0"; // string

    object.pallet_id = "0"; // string

    object.upc = "0"; // string
    object.fcsku = ""; // string

    object.qty = 1; // number
    object.item_pkg_weight_uom = producto_pedido.item_pkg_weight_uom; // string
    object.currency_code = producto_pedido.currency_code; // string

    object.recovery_rate_type = producto_pedido.recovery_rate_type; // string
    object.adj_total_recovery = producto_pedido.adj_total_recovery; // number
    object.adj_recovery_rate = producto_pedido.adj_recovery_rate; // number
    object.adj_reason = producto_pedido.adj_reason; // string
    object.fnsku = "0"; // string

    object.listing_id = producto_pedido.listing_id; // string
    object.slot_size = producto_pedido.slot_size; // number
    object.is_parcel = producto_pedido.is_parcel; // boolean
    object.date_in = new Date(); // Date

    console.log(object);
    console.log(producto_pedido);
    productoModule.guardarproducto(object).then(() => {
      this.AllSaveOk();
    });
  }

  public Actualizar(object: producto) {
    object.item_pkg_weight = object.item_pkg_weight * 1000;
    productoModule.modificarproducto(object).then(() => {
      this.AllSaveOk();
    });
  }
}
